<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-document"></i> 订单列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="6">
            <el-input 
              v-model="searchForm.order_sn" 
              placeholder="订单编号"
              prefix-icon="el-icon-document"
              clearable
              size="small"
            ></el-input>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-input 
              v-model="searchForm.consignee" 
              placeholder="收货人"
              prefix-icon="el-icon-user"
              clearable
              size="small"
            ></el-input>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-input 
              v-model="searchForm.tel" 
              placeholder="联系电话"
              prefix-icon="el-icon-phone"
              clearable
              size="small"
            ></el-input>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <el-input 
              v-model="searchForm.address" 
              placeholder="收货地址"
              prefix-icon="el-icon-location"
              clearable
              size="small"
            ></el-input>
          </el-col>
        </el-row>

        <el-row :gutter="16" style="margin-top: 12px">
          <el-col :xs="24" :sm="8" :md="5">
            <el-select
              v-model="searchForm.order_status"
              placeholder="订单状态"
              clearable
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="item in orderStatusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :xs="24" :sm="8" :md="5">
            <el-select
              v-model="searchForm.pay_status"
              placeholder="支付状态"
              clearable
              size="small"
              style="width: 100%"
            >
              <el-option
                v-for="item in payStatusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :xs="24" :sm="16" :md="10">
            <el-date-picker
              v-model="searchForm.start_end_date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              style="width: 100%"
            ></el-date-picker>
          </el-col>
          <el-col :xs="24" :sm="8" :md="4">
            <div class="search-actions">
              <el-button type="primary" @click="searchSubmit" size="small">搜索</el-button>
              <el-button @click="resetSearch" size="small">重置</el-button>
              <el-button type="default" @click="goExcel" size="small" icon="el-icon-download">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon">
            <i class="el-icon-document"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">总订单数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="el-icon-money"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">¥{{ totalAmount }}</div>
            <div class="stat-label">总金额</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="el-icon-check"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ paidCount }}</div>
            <div class="stat-label">已完成</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="small"
          :header-cell-style="headerCellStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column type="index" label="#" width="50" align="center" :index="indexMethod"></el-table-column>
          
          <el-table-column label="订单信息" min-width="220">
            <template slot-scope="scope">
              <div class="order-info">
                <div class="order-sn">{{ scope.row.order_sn }}</div>
                <div class="order-amount">¥{{ scope.row.order_amount }}</div>
                <div class="order-time">{{ scope.row.add_time | dateFormat }}</div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="用户信息" min-width="140">
            <template slot-scope="scope">
              <div class="user-info">
                <div class="user-name">{{ scope.row.user ? scope.row.user.user_name : '-' }}</div>
                <div class="user-phone">{{ scope.row.user ? scope.row.user.mobile : '-' }}</div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="收货信息" min-width="200">
            <template slot-scope="scope">
              <div class="receive-info">
                <div class="receiver">{{ scope.row.consignee || '-' }} {{ scope.row.tel || '-' }}</div>
                <div class="address">{{ scope.row.address || '-' }}</div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="支付" width="100" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.pay_id == 6 ? '微信支付' : (scope.row.pay_name || '-') }}</div>
              <div class="pay-time" v-if="scope.row.pay_time">{{ scope.row.pay_time | timeFormat }}</div>
            </template>
          </el-table-column>
          
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.pay_status == 2" class="status-success">已支付</span>
              <span v-else class="status-wait">待支付</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="80" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="detail-btn" @click="goInfo(scope.row)">
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-document"></i>
        <p>暂无订单数据</p>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'
import * as XLSX from 'xlsx'

export default {
  name: "orderList",
  data() {
    return {
      loading: false,
      
      searchForm: {
        order_sn: '',
        consignee: '',
        tel: '',
        address: '',
        order_status: '',
        pay_status: '',
        start_end_date: ''
      },
      
      payStatusList: [
        { id: 0, name: '待付款' },
        { id: 2, name: '已支付' }
      ],
      orderStatusList: [
        { id: 0, name: '待处理' },
        { id: 2, name: '订单关闭' },
        { id: 6, name: '待评价' },
        { id: 7, name: '已完成' }
      ],
      
      paidCount: 0,
      totalAmount: 0,
      
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      showType: ''
    }
  },
  created() {
    this.DataList()
  },
  filters: {
    dateFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD HH:mm")
    },
    timeFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD HH:mm")
    }
  },
  methods: {
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '13px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    
    calculateStats() {
      if (!this.tableLoadData.length) {
        this.paidCount = 0
        this.totalAmount = 0
        return
      }
      this.paidCount = this.tableLoadData.filter(item => item.pay_status == 2).length
      this.totalAmount = this.tableLoadData.reduce((sum, item) => sum + (parseFloat(item.order_amount) || 0), 0).toFixed(2)
    },
    
    resetSearch() {
      this.searchForm = {
        order_sn: '',
        consignee: '',
        tel: '',
        address: '',
        order_status: '',
        pay_status: '',
        start_end_date: ''
      }
      this.pageNum = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    indexMethod(index) { return (this.pageNum - 1) * this.pageSize + index + 1 },
    
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      
      if (this.searchForm.order_sn) param.order_sn = this.searchForm.order_sn
      if (this.searchForm.consignee) param.consignee = this.searchForm.consignee
      if (this.searchForm.address) param.address = this.searchForm.address
      if (this.searchForm.tel) param.tel = this.searchForm.tel
      if (this.searchForm.pay_status !== '') param.pay_status = this.searchForm.pay_status
      if (this.searchForm.order_status !== '') param.order_status = this.searchForm.order_status
      if (this.searchForm.start_end_date && this.searchForm.start_end_date.length === 2) {
        param.start_time = this.searchForm.start_end_date[0]
        param.end_time = this.searchForm.start_end_date[1]
      }
      
      this.$axios.orderList(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    goInfo(row) {
      this.$router.push({
        path: '/shopOrderInfo',
        query: { id: row.order_id }
      })
    },
    
    goExcel() {
      if (!this.tableLoadData.length) {
        this.$message.warning('暂无数据可导出')
        return
      }
      
      const exportData = this.tableLoadData.map((row, index) => ({
        '序号': index + 1,
        '订单编号': row.order_sn,
        '用户名称': row.user ? row.user.user_name : '-',
        '订单金额': row.order_amount,
        '下单时间': moment(row.add_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
        '支付方式': row.pay_id == 6 ? '微信支付' : (row.pay_name || '-'),
        '支付时间': row.pay_time ? moment(row.pay_time * 1000).format('YYYY-MM-DD HH:mm:ss') : '-',
        '收货人': row.consignee || '-',
        '收货电话': row.tel || '-',
        '收货地址': row.address || '-',
        '订单状态': row.pay_status == 2 ? '已支付' : '未支付'
      }))
      
      const worksheet = XLSX.utils.json_to_sheet(exportData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '订单列表')
      
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.href = url
      link.download = `订单列表_${moment().format('YYYYMMDDHHmmss')}.xlsx`
      link.click()
      URL.revokeObjectURL(url)
      
      this.$message.success(`成功导出 ${this.tableLoadData.length} 条数据`)
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb {
    font-size: 14px;
    i {
      margin-right: 4px;
    }
  }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card ::v-deep .el-card__body {
  padding: 20px 24px;
}

// 搜索栏
.search-bar {
  background: #f8f9fc;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .search-actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
}

// 统计卡片
.stat-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  
  .stat-card {
    flex: 1;
    min-width: 150px;
    background: #fff;
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    }
    
    .stat-icon {
      width: 48px;
      height: 48px;
      background: #1677ff;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      i {
        font-size: 24px;
        color: #fff;
      }
    }
    
    .stat-info {
      .stat-value {
        font-size: 24px;
        font-weight: 600;
        color: #1f2d3d;
      }
      .stat-label {
        font-size: 12px;
        color: #8c8f98;
        margin-top: 4px;
      }
    }
  }
}

// 表格样式
.table-wrapper {
  margin-bottom: 20px;
  min-height: 350px;
}

::v-deep .el-table {
  border-radius: 12px;
  overflow: hidden;
  
  &::before {
    display: none;
  }
  
  th {
    background: #fafbfc !important;
  }
  
  td {
    border-bottom: 1px solid #f0f0f0;
  }
  
  .el-table__row {
    transition: background 0.2s;
    &:hover {
      background: #f8f9fc;
    }
  }
}

.order-info {
  .order-sn {
    font-family: monospace;
    font-weight: 500;
    color: #1677ff;
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  .order-amount {
    color: #ff4d4f;
    font-weight: 600;
    margin-bottom: 4px;
  }
  
  .order-time {
    font-size: 12px;
    color: #8c8f98;
  }
}

.user-info {
  .user-name {
    font-weight: 500;
    margin-bottom: 4px;
  }
  
  .user-phone {
    font-size: 12px;
    color: #8c8f98;
  }
}

.receive-info {
  .receiver {
    font-weight: 500;
    margin-bottom: 4px;
  }
  
  .address {
    font-size: 12px;
    color: #8c8f98;
    word-break: break-all;
  }
}

.pay-time {
  font-size: 11px;
  color: #c0c4cc;
  margin-top: 4px;
}

.status-success {
  color: #00b578;
  font-weight: 500;
}

.status-wait {
  color: #e6a23c;
}

.detail-btn {
  color: #1677ff;
  
  &:hover {
    color: #4096ff;
  }
}

// 空状态
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
}

// 分页
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  
  ::v-deep .el-pagination .el-pager li.active {
    background: #1677ff;
    color: #fff;
  }
}

// 响应式
@media (max-width: 768px) {
  .alipay-container {
    padding: 12px;
  }
  
  .search-actions {
    margin-top: 12px;
  }
  
  .stat-cards .stat-card {
    min-width: calc(33.33% - 14px);
  }
}
</style>